import { KeyValueCustomSelect, Text } from "@smartsuite/react-ui/lib";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import type { ReactNode } from "react";
import {
  StyledTitle,
  StyledTopLineOuter,
} from "../../../../../../../../../../components/CaptionBlock/styles";
import { useTheme } from "../../../../../../../../../../stores";
import { useRootStore } from "../../../../../../../../../../stores/hooks";
import { getTimezoneShortLabel } from "../../../../../../../../../../timezone/timezones";
import { getLocalCssColorVariables } from "../../../../../../../../../../utils/cssVariablesUtils";
import * as S from "./style";
import { buildTimeOptions } from "./time-options";
import { useRepeatedSchedule } from "../../repeated-schedule.hook";
interface Props {
  title?: string;
  disabled?: boolean;
  useInDateEditor?: boolean;
}

export const TimeEditor = observer<Props>(
  ({ title, disabled, useInDateEditor }) => {
    const theme = useTheme();
    const { config, automations } = useRootStore();
    const [open, setOpen] = useState<boolean>(false);

    const { scheduleStore } = useRootStore();
    const { getStartFromTime, setStartFromTime } = useRepeatedSchedule();

    const [value, setValue] = useState<number>(() => getStartFromTime());

    useEffect(() => {
      setValue(getStartFromTime());
    }, [scheduleStore.schedule]);

    const onOpendChange = (e: boolean): void => {
      setOpen(e);
    };

    return (
      <S.Wrapper
        marginBottom={title === undefined ? "0px" : "10px"}
        marginLeft={useInDateEditor === true ? "10px" : "0px"}
      >
        {title !== undefined && (
          <StyledTopLineOuter>
            <StyledTitle>{title}</StyledTitle>
          </StyledTopLineOuter>
        )}
        <S.MinWidthSelector>
          <KeyValueCustomSelect
            my="left top+2"
            value={value * 1000}
            showClear={false}
            placeholderArrowStyle="filled-dark"
            state={open ? "active" : "default"}
            // @ts-expect-error:
            options={buildTimeOptions(config.userPreferences)}
            className={`dropdown-panel-min-width ${
              open ? "container-is-open" : ""
            }`}
            portalStyles={getLocalCssColorVariables(theme)}
            onOpenedChange={onOpendChange}
            renderSelectedOption={(option) =>
              renderSelectedOption(
                option.label as string,
                getTimezoneShortLabel(automations.candidate.getTimezone()),
              )
            }
            minWidth={200}
            onChange={(value) => {
              setStartFromTime((value as number) / 1000);
            }}
            showFilter={false}
            disabled={!!disabled}
          />
        </S.MinWidthSelector>
      </S.Wrapper>
    );
  },
);

const renderSelectedOption = (
  label: string,
  timezone: string | undefined,
): ReactNode => {
  return (
    <S.RenderSelectedOption>
      <Text>{label}</Text>
      <S.RenderSelectedOptionTimezone>
        <Text color="inactive" size="xs">
          {timezone}
        </Text>
      </S.RenderSelectedOptionTimezone>
    </S.RenderSelectedOption>
  );
};
